export default {
  STATUS_DRAFT: "Draft",
  STATUS_SUBMITTED: "Submitted",
  STATUS_ACCEPTED: "Accepted",
  STATUS_REJECTED: "Rejected",
  STATUS_CANCELED: "Canceled",
  DELETE_ESTABLISHMENT_INTERNAL_INVOICE: "Delete the establishment internal invoice",
  ADD_ITEMS_FIRST: "Add at least one internal invoice item before submitting.",
  ACCEPT: "Accept",
  REJECT: "Reject",
  SUBMITTED_BY: "Submitted by",
  SUBMITTED_AT: "Submitted at",
  ACCEPTED_BY: "Accepted by",
  ACCEPTED_AT: "Accepted at",
  DISCOUNT: "Rebate",
  INTERNAL_INVOICE_DATE: "Internal invoice date",
  INTERNAL_INVOICE_DATE_HELP:
    "An internal invoice is dated on the ordered day it settles: that date decides which weekly report week it is counted in, whatever the day it is accepted. It cannot be changed.",
};
